

export const platformStateOptions = [
  { label: "待平台初审", value: "00" },
  { label: "待复核打款", value: "01" },
  { label: "待门店打款", value: "02" },
  { label: "追差完成", value: "04" },
  { label: "追差驳回", value: "10" },
  { label: "取消追差", value: "20" },
];

export const formItemList = [
  {
    labelName: "订单号",
    key: "orderNo",
    type: "input",
    lableWidth: "58px",
    placeholder: "请输入查询",
  },
  {
    labelName: "外部订单号",
    key: "orderNoOneline",
    type: "input",
    lableWidth: "90px",
    placeholder: "请输入查询",
  },
  {
    labelName: "售后单号",
    key: "subArgueNo",
    type: "input",
    lableWidth: "90px",
    placeholder: "请输入查询",
  },
  {
    labelName: "串号",
    key: "imei",
    type: "input",
    placeholder: "请输入查询",
  },
  {
    labelName: "门店商家",
    key: "companyId",
    type: "selectFilterable",
    placeholder: "请选择",
    lableWidth: "80px",
    clear: true,
    option: [],
    clearFun: () => false,
  },
  {
    labelName: "回收商家",
    key: "merchantId",
    type: "selectFilterable",
    placeholder: "请选择",
    lableWidth: "80px",
    clear: true,
    option: [],
    clearFun: () => false,
  },
  // {
  //   labelName: "订单是否向外部发起申请",
  //   key: "argueType",
  //   type: "select",
  //   lableWidth: "170px",
  //   placeholder: "请选择",
  //   option: argueTypeOption,
  // },
  {
    lableWidth: "100px",
    labelName: "外部收货时间",
    key: "intoTime",
    type: "daterange",
  },
  {
    lableWidth: "100px",
    labelName: "平台初审时间",
    key: "auditFirstTime",
    type: "daterange",
  },
  {
    lableWidth: "100px",
    labelName: "提交售后时间",
    key: "createTime",
    type: "daterange",
  },
  {
    lableWidth: "100px",
    labelName: "审核通过时间",
    key: "finishTime",
    type: "daterange",
  },

  {
    lableWidth: "100px",
    labelName: "售后驳回时间",
    key: "rejectTime",
    type: "daterange",
  },
  {
    labelName: "售后提交方式",
    key: "applyType",
    type: "select",
    lableWidth: "100px",
    placeholder: "请选择",
    option: [
      { label: "手动提交", value: "00" },
      { label: "系统提交", value: "01" },
    ],
  },
];

export const tabData = [
  {
    text: "待申请",
    value: "00",
    num: 0,
    key: "waitApplyNum",
  },
  {
    text: "待审核",
    value: "01",
    num: 0,
    key: "waitApproveNum",
  },
  {
    text: "已通过",
    value: "02",
    num: 0,
    key: "finishNum",
  },
  {
    text: "已驳回",
    value: "10",
    num: 0,
    key: "rejectNum",
  },
];

export const describeData = [
  {
    type: "满足自动申请条件",
    shuoming: [
      "1.商户已启用自动提交追差；",
      "2.平台初审通过时，选择门店商责任或共同责任；",
      "3.该订单未向外部发起过追差",
    ],
  },
  {
    type: "申请金额",
    shuoming: [
      "初审通过门店商承担金额≤外部成交金额：取门店商承担金额",
      "初审通过门店商承担金额＞外部成交金额：取外部成交金额",
    ],
  },
  {
    type: "追差类型",
    shuoming: [
      "采货侠渠道：取关联繁星平台的追差分类的外部追差类型，若未关联则不执行自动提交",
      "非采货侠渠道：无需传该字段",
    
    ],
  },
  {
    type: "追差备注",
    shuoming: [
      "采货侠渠道：取初审通过平台审差填写的判责理由，超出部分自动截取",
      "其他渠道：取回收商选择追差类型+初审通过判责原因内容，超出部分自动截取",
    ],
  },
  {
    type: "追差凭证",
    shuoming: [
      "取回收商发起追差上传的照片、视频",
    ],
  },
];

export const tableData = {
  loading: false,
  // 当前数据
  currentData: {},
  // 表数据
  data: [],
  // 表列
};

// 表列
export const platformTableColumns = [
  {
    prop: "images",
    label: "旧机照片",
  },
  {
    prop: "phoneName",
    label: "机型",
  },
  {
    prop: "imei",
    label: "串号",
  },
  {
    prop: "createCompanyName",
    label: "门店商户",
  },
  {
    prop: "manualQuotePrice",
    label: "回收商报价",
  },
  {
    prop: "chxPrice",
    label: "外部成交价",
  },

  {
    prop: "auditFirstAdminName",
    label: "初审人",
    isHide: false,
  },
  {
    prop: "auditFirstTime",
    label: "初审通过时间",
    isHide: false,
  },
  {
    prop: "arguePriceAuditS",
    label: "初审通过金额",
    isHide: false,
  },

  {
    prop: "applyAdminName",
    label: "提交人",
    isHide: true,
  },
  {
    prop: "applyTime",
    label: "提交时间",
    isHide: true,
  },
  {
    prop: "arguePrice",
    label: "提交金额",
    isHide: true,
  },

  {
    prop: "argueNote",
    label: "售后原因",
  },

  // {
  //   prop: "accountType",
  //   label: "差异款到账账户",
  //   // 控制是否隐藏当前
  //   isHide: true,
  // },
  {
    prop: "finishTime",
    label: "审核通过时间",
    // 控制是否隐藏当前
    isHide: true,
  },
  {
    prop: "amount",
    label: "补差金额（审核通过）",
    // 控制是否隐藏当前
    isHide: true,
  },
  {
    prop: "rejectTime",
    label: "驳回时间",
    // 控制是否隐藏当前
    isHide: true,
  },
  {
    prop: "auditNote",
    label: "审核备注",
    // 控制是否隐藏当前
    isHide: true,
  },
  {
    prop: "action",
    width: "300px",
    label: "操作",
  },
];

export const photoDialogProp = {
  show: false,
  photoArr: [],
};

export const chxStateOptions = [
  { label: "待申请", value: "00" },
  { label: "待审核", value: "01" },
  { label: "已通过", value: "02" },
  { label: "已驳回", value: "10" },
];
